import { css, SimpleInterpolation } from 'styled-components';

import { THeaderLevel } from '@r1-frontend/ui-kit/atoms/typography/heading/types';
import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';

// @todo write tests
export const getFontSize = (level: THeaderLevel) => (
    { theme: { typography: { headers }, breakpoints } }: ThemedProperties,
): SimpleInterpolation => {
    return css`
        font-size: ${headers[`h${level}`].mobile.fs}px;
        line-height: ${headers[`h${level}`].mobile.lh}px;

        @media (min-width: ${breakpoints.mobile}) {
            font-size: ${headers[`h${level}`].desktop.fs}px;
            line-height: ${headers[`h${level}`].desktop.lh}px;
        }
    `;
};
